export default __webpack_public_path__ + "static/media/key.3d992aec.svg";